import Immutable from 'seamless-immutable';
import {
  GET_ME_SUCCEEDED,
  GET_ME_FAILED,
  GET_CURRICULUMS_SUCCEEDED,
  GET_GRADES_SUCCEEDED,
  GET_GRADE_DETAILS_SUCCEEDED,
  GET_GRADE_DETAILS,
  GET_SKILL_CONFIGS_SUCCEEDED,
  ADD_QUESTION_TO_DOWNLOAD,
  REMOVE_QUESTION_TO_DOWNLOAD,
  REMOVE_ALL_QUESTION_TO_DOWNLOAD,
  ADD_SECTION,
  REMOVE_SECTION,
  DRAG_UPDATE,
  EDIT_SECTION,
  GET_SKILL_CONFIGS,
  GET_TOPIC_CONFIGS,
  GET_CONCEPT_CONFIGS,
  SAVE_EXAM_INSTRUCTION,
  SAVE_INSTRUCTION,
  CLEAR_DOWNLOAD,
  SEND_FOR_DOWNLOAD_SUCCEEDED,
  GET_CCFILTRERS,
  GET_CCFILTRERS_SUCCEEDED,
  GET_CCSubjects,
  GET_CCSubjects_SUCCEEDED,
} from "./action";

import { b64DecodeUnicode, dragDropOrderGenerator, parseQuestionResponse } from './utils';

export const initialState = Immutable({
  userSession: {
    user: undefined,
    tokenRefreshed: false, // true when jwt expires
    loggedOut: false,
    isAuthenticated: false,
  },
  curriculums: undefined,
  grades: undefined,
  gradeDetails: undefined,
  skillConfigs: undefined,
  questionToDownload: [],
  questionIdArr: [],
  questionOrderArr: [],
  statistics: {
    difficulty: {
      easy: 0,
      medium: 0,
      hard: 0,
    },
    topics: {},
    total: 0
  }
});

export default (state = initialState, action) => {
  if (action.resp && action.resp.hasOwnProperty('tokenRefreshed')) {
    const tokenRefreshed = action.resp.tokenRefreshed;
    state = state.merge({
      userSession: state.userSession.merge({
        tokenRefreshed: true,
      }),
    });
  }
  switch (action.type) {
    case GET_ME_SUCCEEDED:
      return state.merge({
        userSession: state.userSession.merge({
          user: action.resp.data,
          tokenRefreshed: false,
          loggedOut: false,
          isAuthenticated: true,
        }),
      });
    case GET_CURRICULUMS_SUCCEEDED:
      return state
        .setIn(["curriculums"], action.payload.curriculums)
        // .setIn(["grades"], [])
        .setIn(["gradeDetails"], []);
    case GET_GRADES_SUCCEEDED:
      return state
        .setIn(["grades"], action.payload)
        .setIn(["gradeDetails"], []);
    case GET_GRADE_DETAILS:
      return state.setIn(["gradeDetails"], []);
    case GET_GRADE_DETAILS_SUCCEEDED:
      return state.setIn(["gradeDetails"], action.payload);
    case GET_CCFILTRERS:
      return state.setIn(["filterConfigs"], undefined);
    case GET_CCSubjects:
      return state.setIn(["subjectConfigs"], undefined);
    case GET_SKILL_CONFIGS:
      if (action.payload.offset == 0) {
        return state.setIn(["skillConfigs"], undefined);
      } else {
        return state;
      }
    case GET_TOPIC_CONFIGS:
      if (action.payload.offset == 0) {
        return state.setIn(["skillConfigs"], undefined);
      } else {
        return state;
      }
    case GET_CONCEPT_CONFIGS:
      if (action.payload.offset == 0) {
        return state.setIn(["skillConfigs"], undefined);
      } else {
        return state;
      }
    case GET_CCFILTRERS_SUCCEEDED:
      return state.setIn(["filterConfigs"], action.payload);
    case GET_CCSubjects_SUCCEEDED:
      return state.setIn(["subjectConfigs"], action.payload);
    case GET_SKILL_CONFIGS_SUCCEEDED:
      let newData = JSON.parse(JSON.stringify(action.payload));
      if (!!state.skillConfigs) {
        newData.results = [...state.skillConfigs.results, ...newData.results];
      }
      return state.setIn(
        ["skillConfigs"],
        !!state.skillConfigs ? newData : action.payload
      );
    case GET_ME_FAILED:
      return state.setIn(["userSession", "user"], "failed");
    case ADD_QUESTION_TO_DOWNLOAD:
      let tempArr = JSON.parse(JSON.stringify(state.questionToDownload));
      let tempIdArr = JSON.parse(JSON.stringify(state.questionIdArr));
      if (!state.questionIdArr.includes(action.payload.question_id)) {
        tempIdArr.push(action.payload.question_id);
        tempArr.push(action.payload);
      }
      let questionDifficulty = JSON.parse(
        JSON.stringify(state.statistics.difficulty)
      );
      let topicsObj = JSON.parse(JSON.stringify(state.statistics.topics));
      if (action.payload.topic_name in topicsObj) {
        topicsObj[action.payload.topic_name] += 1;
      } else {
        topicsObj[action.payload.topic_name] = 1;
      }
      questionDifficulty[action.payload.difficulty_level] += 1;
      return state
        .setIn(["questionToDownload"], tempArr)
        .setIn(["questionIdArr"], tempIdArr)
        .setIn(["questionOrderArr"], dragDropOrderGenerator(tempIdArr))
        .setIn(["statistics", "total"], tempIdArr.length)
        .setIn(["statistics", "difficulty"], questionDifficulty)
        .setIn(["statistics", "topics"], topicsObj);
    case REMOVE_QUESTION_TO_DOWNLOAD:
      let tempArr2 = JSON.parse(JSON.stringify(state.questionToDownload));
      let tempIdArr2 = JSON.parse(JSON.stringify(state.questionIdArr));
      let questionDifficulty1 = JSON.parse(
        JSON.stringify(state.statistics.difficulty)
      );
      let topicsObj1 = JSON.parse(JSON.stringify(state.statistics.topics));
      if (state.questionIdArr.includes(action.payload.question_id)) {
        tempIdArr2.splice(tempIdArr2.indexOf(action.payload.question_id), 1);
        let tempIndex = 0;
        tempArr2.map((item, index) => {
          if (item.question_id == action.payload.question_id) {
            tempIndex = index;
          }
        });
        tempArr2.splice(tempIndex, 1);
        questionDifficulty1[action.payload.difficulty_level] -= 1;
        if (topicsObj1[action.payload.topic_name] > 1) {
          topicsObj1[action.payload.topic_name] -= 1;
        } else {
          delete topicsObj1[action.payload.topic_name];
        }
      }
      return state
        .setIn(["questionToDownload"], tempArr2)
        .setIn(["questionIdArr"], tempIdArr2)
        .setIn(["questionOrderArr"], dragDropOrderGenerator(tempIdArr2))
        .setIn(["statistics", "total"], tempIdArr2.length)
        .setIn(["statistics", "difficulty"], questionDifficulty1);
    case REMOVE_ALL_QUESTION_TO_DOWNLOAD:
      return state
        .setIn(["questionToDownload"], [])
        .setIn(["questionIdArr"], [])
        .setIn(["statistics"], {
          difficulty: {
            easy: 0,
            medium: 0,
            hard: 0,
          },
          topics: {},
          total: 0,
        });
    case ADD_SECTION:
      let tempArr3 = JSON.parse(JSON.stringify(state.questionToDownload));
      let tempIdArr3 = JSON.parse(JSON.stringify(state.questionIdArr));
      let tempSection = {
        section_name: "",
        marks: 0,
      };
      tempArr3.unshift(tempSection);
      tempIdArr3.unshift(tempSection);
      return state
        .setIn(["questionToDownload"], tempArr3)
        .setIn(["questionIdArr"], tempIdArr3)
        .setIn(["questionOrderArr"], dragDropOrderGenerator(tempIdArr3));
    case DRAG_UPDATE:
      let tempAr = action.payload;
      let tempIdAr = [];
      tempAr.map((item, index) => {
        if ("section_name" in item) {
          tempIdAr.push(item);
        } else {
          tempIdAr.push(item.question_id);
        }
      });
      return state
        .setIn(["questionToDownload"], tempAr)
        .setIn(["questionIdArr"], tempIdAr)
        .setIn(["questionOrderArr"], dragDropOrderGenerator(tempIdAr));
    case REMOVE_SECTION:
      let tempArr4 = JSON.parse(JSON.stringify(state.questionToDownload));
      let tempIdArr4 = JSON.parse(JSON.stringify(state.questionIdArr));
      tempArr4.splice(action.payload, 1);
      tempIdArr4.splice(action.payload, 1);
      return state
        .setIn(["questionToDownload"], tempArr4)
        .setIn(["questionIdArr"], tempIdArr4)
        .setIn(["questionOrderArr"], dragDropOrderGenerator(tempIdArr4));
    case EDIT_SECTION:
      let tempArr5 = JSON.parse(JSON.stringify(state.questionToDownload));
      let tempIdArr5 = JSON.parse(JSON.stringify(state.questionIdArr));
      const { data, pos } = action.payload;
      tempArr5[pos] = data;
      tempIdArr5[pos] = data;
      return state
        .setIn(["questionToDownload"], tempArr5)
        .setIn(["questionIdArr"], tempIdArr5)
        .setIn(["questionOrderArr"], dragDropOrderGenerator(tempIdArr5));
    case SAVE_EXAM_INSTRUCTION:
      return state.setIn(["examUserInstruction"], action.examObj)
    case SAVE_INSTRUCTION:
        return state.setIn(["instruction"], action.payload);
    case SEND_FOR_DOWNLOAD_SUCCEEDED:
        return state.setIn(["download"], true);
    case CLEAR_DOWNLOAD:
        return state.setIn(["download"], undefined);  
    default:
      return state;
  }
};
